import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from 'src/infrastructure/config';
import { Cards } from 'src/models/DTO/card/Cards';
import { PaymentIntents } from 'src/models/DTO/paymentIntents/paymentIntents';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  private stripeGetPaymentMethodsURL : string = Config.stripeAPI + "customers/<user_id>/payment_methods";
  private stripeAttachPaymentMethodsURL : string = Config.stripeAPI + "payment_methods/<payment_method>/attach";
  private stripeDettachPaymentMethodsURL : string = Config.stripeAPI + "payment_methods/<payment_method>/detach";
  private stripeGetPaymentIntentDetails : string = Config.stripeAPI + "payment_intents";


  private user = "cus_NzCsVBxERVXC1O";

  constructor(private httpClient: HttpClient) { }

  public attachPaymentMethod(paymentMethodId: string, user: string) {
    const url = this.stripeAttachPaymentMethodsURL.replace('<payment_method>', paymentMethodId);
    const headers = this.createHeaders();
    const body = new HttpParams()
    .set('customer', user)
    return this.httpClient.post(url, body.toString(), { headers: headers } );
  }

  public detachPaymentMethod(paymentMethodId: string) {
    const url = this.stripeDettachPaymentMethodsURL.replace('<payment_method>', paymentMethodId);
    const headers = this.createHeaders();
    return this.httpClient.post(url, '', { headers: headers } );
  }

  public getPaymentMethods(user: string) {
    const url = this.stripeGetPaymentMethodsURL.replace('<user_id>', user);
    const headers = this.createHeaders();
    return this.httpClient.get<Cards>(url, {headers: headers });
  }

  public getPaymentIntentDetails(paymentIntent: string) {
    const url = this.stripeGetPaymentIntentDetails + '/' + paymentIntent;
    const headers = this.createHeaders();
    return this.httpClient.get<PaymentIntents>(url, {headers: headers });
  }

  private createHeaders() {
    let httpHeaders= new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + Config.stripeAPIKEY });
    return httpHeaders;
  }
}
